export const defaultBoxStyles = {
  padding: "1rem 0",
};

export const dateFieldStyles = {
  ".MuiInputBase-root": {
    background: "white",
  },
};

export const hourFieldStyles = {
  width: "120px",
};

export const hourSelectStyles = {
  background: "white",
};

export const hourOptionStyles = {
  margin: "0.5rem",
};

export const hourDividerStyles = {
  fontSize: "3rem",
  lineHeight: 1,
};
